<!--banner starts-->
<div class="uk-child-width-1-1@s" uk-grid>
  <div>
      <div class="uk-background-cover uk-height-large uk-panel uk-flex-center uk-flex-middle"
             style="background-image: url(../../assets/teambanner.png);">
          <div class="uk-section uk-light">
              <div class="uk-container-small uk-width-2xlarge" style="padding-top: 60px;">
                  <div><h1 class="uk-text-bold uk-padding-large uk-padding-remove-vertical"  style="margin-bottom: 10px;">Our team <br></h1></div>
                  <div>
                      <p class="uk-padding-large uk-text-left  uk-padding-remove-vertical" style= "font-size: 20px;">At WebSoulLabs nothing is more worth than unity and understanding. Here comes the power of our teams.
                       
                      </p>
                  </div>
              </div>
          </div>
      </div>
  </div>
</div>       
<!--banner ends-->

<div class="uk-section  uk-padding">
    <h1 class="uk-text-center " style="font-weight: 600;">Our Team</h1>
    <p class="uk-text-justify" style="font-size:18px">
        Each member of our team is a specialist in their own field. Together, we make sure you’re investing where the best returns are, while building loyalty across every milestone.We're not just dedicated to making technology work for your business, we're committed to helping you explore the digital market, identify opportunities, quickly and accurately create solutions to suit your business needs and then position your firm for success in the rapidly growing market scenario.
    </p>
    <p class="uk-text-justify" style="font-size:18px">We understand how to navigate today's disruptive markets as they evolve, working with you to identify hidden and new resources of value. Our team's deep experience will help you design a perfect transformation pathway that meets your business goals.Our team consists of highly qualified, experienced and knowledgeable industry professionals that are always passionate and pure to our clients.We are a team because we respect, believe & care for each other. </p>
</div>
<div class="uk-section  uk-padding" style="background-color: rgb(120, 120, 120)">
  
  <div class="uk-container uk-container-large">
      <h2 class="uk-text-center uk-light">Directors</h2>
      <div class="uk-grid-medium uk-child-width-1-2@s uk-child-width-1-4@m uk-grid-match uk-flex-center" uk-grid>
          <div>
              <div class="uk-light uk-animation-toggle" tabindex="0">
                  <img class="uk-border-circle uk-align-center uk-animation-slide-top-medium " style="margin-bottom: 10px;" src="assets/a2.png" style="width: 250px; height: 250px;"
                  alt="border-circle">
                  <h4 class="uk-text-center uk-text-uppercase" style="margin-top: 0px; margin-bottom: 10px;">ANEESH T</h4>
                  <P class="uk-text-center" style="margin-top:0px ;">Founder, MD & CEO</P>
                  <div class="uk-text-center">
                    <a href="https://www.linkedin.com/in/aneesh-t-7955b7160" class="uk-icon-button uk-button-secondary uk-margin-small-right" uk-icon="linkedin"></a>
                    <a href="https://www.facebook.com/aneeshtn.tn" class="uk-icon-button uk-button-secondary uk-margin-small-right" uk-icon="facebook"></a>
                    <a href="https://instagram.com/aneesh_tn?igshid=1dxb09dtfcwcv" class="uk-icon-button uk-button-secondary uk-margin-small-right" uk-icon="instagram"></a>
                    <a href="https://twitter.com/AneeshtAneesh" class="uk-icon-button uk-button-secondary uk-margin-small-right" uk-icon="twitter"></a>
                </div>
              </div>
          </div>
          <!-- <div>
              <div class="uk-light uk-animation-toggle" tabindex="0">
                  <img class="uk-border-circle uk-align-center uk-animation-slide-top-medium" style="margin-bottom: 10px;" src="assets/a3.png" style="width: 250px; height: 250px;"
                  alt="border-circle">
                  <h4 class="uk-text-center uk-text-uppercase" style="margin-top: 0px; margin-bottom: 10px;">ANIL T</h4>
                  <P class="uk-text-center" style="margin-top:0px ;">Chairman & Director</P>
                  <div class="uk-text-center">
                    <a href=" https://www.linkedin.com/in/anil-t-2b28781b6" class="uk-icon-button uk-button-secondary uk-margin-small-right" uk-icon="linkedin"></a>
                    <a href="https://www.facebook.com/anil.tn2" class="uk-icon-button uk-button-secondary uk-margin-small-right" uk-icon="facebook"></a>
                    <a href="https://instagram.com/anilt_90?igshid=197znwbbmk1u8" class="uk-icon-button uk-button-secondary uk-margin-small-right" uk-icon="instagram"></a>
                    <a href="https://twitter.com/Anil77842320?s=09" class="uk-icon-button uk-button-secondary uk-margin-small-right" uk-icon="twitter"></a>
                </div>
              </div>
          </div>  -->
          <!-- <div>
              <div class="uk-light uk-animation-toggle" tabindex="0">
                  <img class="uk-border-circle uk-align-center uk-animation-slide-top-medium" style="margin-bottom: 10px;" src="assets/a1.png" style="width: 250px; height: 250px;"
                  alt="border-circle">
                  <h4 class="uk-text-center uk-text-uppercase" style="margin-top: 0px; margin-bottom: 10px;">REVATHY ANIL</h4>
                  <P class="uk-text-center" style="margin-top:0px ;">General Manager & Director</P>
                  <div class="uk-text-center">
                    <a href=" https://www.linkedin.com/in/revathi-anil-02136643" class="uk-icon-button uk-button-secondary uk-margin-small-right" uk-icon="linkedin"></a>
                    <a href="https://www.facebook.com/anil.tn2" class="uk-icon-button uk-button-secondary uk-margin-small-right" uk-icon="facebook"></a>
                    <a href="https://instagram.com/revathyanil0503?igshid=1d6o2xa9ekdkr" class="uk-icon-button uk-button-secondary uk-margin-small-right" uk-icon="instagram"></a>
                    <a href="https://twitter.com/anil_revathi?s=08" class="uk-icon-button uk-button-secondary uk-margin-small-right" uk-icon="twitter"></a>
                </div>
              </div>
          </div>         -->
      </div>
  </div>
  <br>
  
  <div class="uk-container uk-container-large">
    <h2 class="uk-text-center uk-light">HR Team</h2>
    <div class="uk-grid-medium uk-child-width-1-2@s uk-child-width-1-4@m uk-grid-match uk-flex-center" uk-grid>
        <div>
            <div class="uk-light uk-animation-toggle" tabindex="0">
                <img class="uk-border-circle uk-align-center uk-animation-slide-top-medium " style="margin-bottom: 10px;" src="assets/jeminphto.png" style="width: 250px; height: 250px;"
                alt="border-circle">
                <h4 class="uk-text-center uk-text-uppercase" style="margin-top: 0px; margin-bottom: 10px;">JEMIN JOHN SUNNY</h4>
                <P class="uk-text-center"  style="margin-top:0px ;">HR Executive</P>
               
            </div>
        </div>
        <div>
            <div class="uk-light uk-animation-toggle" tabindex="0">
                <img class="uk-border-circle uk-align-center uk-animation-slide-top-medium" style="margin-bottom: 10px;" src="assets/hr/JOHN.png" style="width: 250px; height: 250px;"
                alt="border-circle">
                <h4 class="uk-text-center uk-text-uppercase" style="margin-top: 0px; margin-bottom: 10px;">JOHN XAVIER</h4>
                <P  class="uk-text-center" style="margin-top:0px ;">HR Executive</P>
                
            </div>
        </div>       
    </div>
</div>
<br>
<div class="uk-container uk-container-large">
  <h2 class="uk-text-center uk-light">Business Development Team</h2>
  
  <div class="uk-grid-medium uk-child-width-1-2@s uk-child-width-1-4@m uk-grid-match uk-flex-center" uk-grid>
    <div>
        <div class="uk-light uk-animation-toggle" tabindex="0">
            <img class="uk-border-circle uk-align-center uk-animation-slide-top-medium" style="margin-bottom: 10px;" src="assets/b/EBNU.png" style="width: 250px; height: 250px;"
            alt="border-circle">
            <h4 class="uk-text-center uk-text-uppercase" style="margin-top: 0px; margin-bottom: 10px;"> EBNU RAPHY</h4>
            <P  class="uk-text-center" style="margin-top:0px ;">Team Lead & Business Development Executive</P>
            <div class="uk-text-center">
                <a href="https://www.linkedin.com/in/ebnu-raphy-b04a351a6" class="uk-icon-button uk-button-secondary uk-margin-small-right" uk-icon="linkedin"></a>
                <a href="https://www.facebook.com/ebnu.raphy" class="uk-icon-button uk-button-secondary uk-margin-small-right" uk-icon="facebook"></a>
                <a href="https://www.instagram.com/p/CCWBuy8nlo0/?igshid=5vczyarb4510" class="uk-icon-button uk-button-secondary uk-margin-small-right" uk-icon="instagram"></a>
                <a href="" class="uk-icon-button uk-button-secondary uk-margin-small-right" uk-icon="twitter"></a>
            </div>
        </div>
    </div> 
    <div>
          <div class="uk-light uk-animation-toggle" tabindex="0"><img class="uk-border-circle uk-align-center 
              uk-animation-slide-top-medium" src="assets/b/DHANEESH.png" style="width: 250px; height: 250px;
               "alt="border-circle">
              <h4 class="uk-text-uppercase uk-text-center" style="margin-top: 0px; margin-bottom: 10px;">DHANEESH K</h4>
              <P class="uk-text-center" style="margin-top:0px ;"> Business <br> Development Executive</P>
              <div class="uk-text-center">
                    <a href="https://www.linkedin.com/in/dhaneesh-k-519869168" class="uk-icon-button uk-button-secondary uk-margin-small-right" uk-icon="linkedin"></a>
                    <a href="https://www.facebook.com/dhaneesh.appu.39" class="uk-icon-button uk-button-secondary uk-margin-small-right" uk-icon="facebook"></a>
                    <a href="https://www.instagram.com/invites/contact/?i=fkse5f2rm6i0&utm_content=9yx2m7m" class="uk-icon-button uk-button-secondary uk-margin-small-right" uk-icon="instagram"></a>
                    <a href="https://twitter.com/DHANEESHK8?s=08" class="uk-icon-button uk-button-secondary uk-margin-small-right" uk-icon="twitter"></a>
              </div>
            </div>
      </div>
      <div>
          <div class="uk-light uk-animation-toggle" tabindex="0"><img class="uk-border-circle uk-align-center 
              uk-animation-slide-top-medium" src="assets/b/CLIFFIN.png" style="width: 250px; height: 250px;
               "alt="border-circle">
              <h4 class="uk-text-uppercase uk-text-center" style="margin-top: 0px; margin-bottom: 10px;">CLIFFIN KURISHINGAL JOSE</h4>
              <P class="uk-text-center" style="margin-top:0px ;">Business <br>Development Executive</P>
              <div class="uk-text-center">
                <a href="https://www.linkedin.com/in/cliffin-k-1750861a7" class="uk-icon-button uk-button-secondary uk-margin-small-right" uk-icon="linkedin"></a>
                <a href="https://www.facebook.com/websoullabs.cliffin" class="uk-icon-button uk-button-secondary uk-margin-small-right" uk-icon="facebook"></a>
                <a href="https://www.instagram.com/websoullcliffin/" class="uk-icon-button uk-button-secondary uk-margin-small-right" uk-icon="instagram"></a>
                <a href="https://mobile.twitter.com/WebsoullabsC" class="uk-icon-button uk-button-secondary uk-margin-small-right" uk-icon="twitter"></a>
            </div>
          </div>
      </div>
      
      
    </div>
</div>
<br>
<div class="uk-container uk-container-large">
  <h2 class="uk-text-center uk-light">Web Development Team</h2>
  <div class="uk-grid-medium uk-child-width-1-2@s uk-child-width-1-4@m uk-grid-match uk-flex-center" uk-grid>
      <div>
          <div class="uk-light uk-animation-toggle" tabindex="0"><img class="uk-border-circle uk-align-center uk-animation-slide-top-medium" style="margin-bottom: 10px;" src="assets/W/MARIA.png" style="width: 250px; height: 250px;"
              alt="border-circle">
              <h4 class="uk-text-uppercase uk-text-center" style="margin-top: 0px; margin-bottom: 10px;">Maria Euelin Souza</h4>
              <P class="uk-text-center" style="margin-top:0px ;">Team lead & Senior Web Developer</P>
          </div>
      </div>
     
      <div>
        <div class="uk-light uk-animation-toggle" tabindex="0"><img class="uk-border-circle uk-align-center uk-animation-slide-top-medium" src="assets/W/ATHUL.png" style="width: 250px; height: 250px;"
            alt="border-circle">
            <h4 class="uk-text-uppercase uk-text-center" style="margin-top: 0px; margin-bottom: 10px;">Athul C R</h4>
            <P class="uk-text-center" style="margin-top:0px ;">Senior Web Developer</P>
            </div>
    </div>
    <div>
        <div class="uk-light uk-animation-toggle" tabindex="0"><img class="uk-border-circle uk-align-center uk-animation-slide-top-medium" style="margin-bottom: 10px;" src="assets/W/BENCY.png" style="width: 250px; height: 250px;"
            alt="border-circle">
            <h4 class="uk-text-uppercase uk-text-center" style="margin-top: 0px; margin-bottom: 10px;">Bency Philip </h4>
            <P class="uk-text-center" style="margin-top:0px ;">Senior Web Developer</P>
        </div>
    </div>
    <div>
        <div class="uk-light uk-animation-toggle" tabindex="0"><img class="uk-border-circle uk-align-center uk-animation-slide-top-medium" style="margin-bottom: 10px;" src="assets/W/SUJI.png"  style="width: 250px; height: 250px;"
            alt="border-circle">
            <h4 class="uk-text-uppercase uk-text-center" style="margin-top: 0px; margin-bottom: 10px;">Suji Anna George </h4>
            <P class="uk-text-center" style="margin-top:0px ;">Senior Web Developer</P>
        </div>
    </div>
      <div>
          <div class="uk-light uk-animation-toggle" tabindex="0"><img class="uk-border-circle uk-align-center uk-animation-slide-top-medium" style="margin-bottom: 10px;" src="assets/W/VIGNESH.png"  style="width: 250px; height: 250px;"
              alt="border-circle">
              <h4 class="uk-text-uppercase uk-text-center" style="margin-top: 0px; margin-bottom: 10px;">Vignesh K</h4>
              <P class="uk-text-center" style="margin-top:0px ;">Senior Web Developer</P>
          </div>
      </div>
      <div>
        <div class="uk-light uk-animation-toggle" tabindex="0"><img class="uk-border-circle uk-align-center 
            uk-animation-slide-top-medium" src="assets/W/ASWATHY.png" style="width: 250px; height: 250px;
             "alt="border-circle">
            <h4 class="uk-text-uppercase uk-text-center" style="margin-top: 0px; margin-bottom: 10px;">Aswathy K P</h4>
            <P class="uk-text-center" style="margin-top:0px ;">Junior Web Developer</P>
        </div>
    </div>
      
      
      <div>
          <div class="uk-light uk-animation-toggle" tabindex="0"><img class="uk-border-circle uk-align-center uk-animation-slide-top-medium" style="margin-bottom: 10px;" src="assets/W/FARHANA.png" style="width: 250px; height: 250px;"
              alt="border-circle">
              <h4 class="uk-text-uppercase uk-text-center" style="margin-top: 0px; margin-bottom: 10px;">Farhana P Salim</h4>
              <P class="uk-text-center" style="margin-top:0px ;">Junior Web Developer</P>
          </div>
      </div>
        <div>
            <div class="uk-light uk-animation-toggle" tabindex="0"><img class="uk-border-circle uk-align-center 
                uk-animation-slide-top-medium" src="assets/W/pic13.png" style="width: 250px; height: 250px;
                "alt="border-circle">
                <h4 class="uk-text-uppercase uk-text-center" style="margin-top: 0px; margin-bottom: 10px;">Gopika K V </h4>
                <P class="uk-text-center" style="margin-top:0px ;">Junior Web Developer</P>
            </div>
        </div>
        <div>
            <div class="uk-light uk-animation-toggle" tabindex="0"><img class="uk-border-circle uk-align-center uk-animation-slide-top-medium" style="margin-bottom: 10px;" src="assets/W/PIC11.png"  style="width: 250px; height: 250px;"
                alt="border-circle">
                <h4 class="uk-text-uppercase uk-text-center" style="margin-top: 0px; margin-bottom: 10px;">Heera K B</h4>
                <P class="uk-text-center" style="margin-top:0px ;">Junior Web Developer</P>
            </div>
        </div>
        <div>
            <div class="uk-light uk-animation-toggle" tabindex="0"><img class="uk-border-circle uk-align-center uk-animation-slide-top-medium" style="margin-bottom: 10px;" src="assets/W/JINITHA.png" style="width: 250px; height: 250px;"
                alt="border-circle">
                <h4 class="uk-text-uppercase uk-text-center" style="margin-top: 0px; margin-bottom: 10px;">Jinitha JOY</h4>
                <P class="uk-text-center" style="margin-top:0px ;">Junior Web Developer</P>
            </div>
        </div>
     
   
     
    
      <div>

        <div class="uk-light uk-animation-toggle" tabindex="0"><img class="uk-border-circle uk-align-center uk-animation-slide-top-medium" style="margin-bottom: 10px;" src="assets/W/jobychacko.png"  style="width: 250px; height: 250px;"
            alt="border-circle">
            <h4 class="uk-text-uppercase uk-text-center" style="margin-top: 0px; margin-bottom: 10px;">Joby Chacko </h4>
            <P class="uk-text-center" style="margin-top:0px ;">Junior Web Developer</P>
        </div>
     </div>
    

          
      

    <div>
        <div class="uk-light uk-animation-toggle" tabindex="0"><img class="uk-border-circle uk-align-center uk-animation-slide-top-medium" style="margin-bottom: 10px;" src="assets/W/STAICY.png"  style="width: 250px; height: 250px;"
            alt="border-circle">
            <h4 class="uk-text-uppercase uk-text-center" style="margin-top: 0px; margin-bottom: 10px;">Staicy Androose</h4>
            <P class="uk-text-center" style="margin-top:0px ;">Junior Web Developer</P>
        </div>
    </div>
    <div>
        <div class="uk-light uk-animation-toggle" tabindex="0"><img class="uk-border-circle uk-align-center uk-animation-slide-top-medium" style="margin-bottom: 10px;" src="assets/W/soniya.png"  style="width: 250px; height: 250px;"
            alt="border-circle">
            <h4 class="uk-text-uppercase uk-text-center" style="margin-top: 0px; margin-bottom: 10px;">Soniya S</h4>
            <P class="uk-text-center" style="margin-top:0px ;">Junior Web Developer</P>
        </div>
    </div>
    <div>
        <div class="uk-light uk-animation-toggle" tabindex="0"><img class="uk-border-circle uk-align-center uk-animation-slide-top-medium" style="margin-bottom: 10px;" src="assets/W/pic14.png"  style="width: 250px; height: 250px;"
            alt="border-circle">
            <h4 class="uk-text-uppercase uk-text-center" style="margin-top: 0px; margin-bottom: 10px;">Shahanas PV</h4>
            <P class="uk-text-center" style="margin-top:0px ;">Junior Web Developer</P>
        </div>
    </div>
    <div>
        <div class="uk-light uk-animation-toggle" tabindex="0"><img class="uk-border-circle uk-align-center uk-animation-slide-top-medium" style="margin-bottom: 10px;" src="assets/W/PIC12.png"  style="width: 250px; height: 250px;"
            alt="border-circle">
            <h4 class="uk-text-uppercase uk-text-center" style="margin-top: 0px; margin-bottom: 10px;">Shahanaz N A</h4>
            <P class="uk-text-center" style="margin-top:0px ;">Junior Web Developer</P>
        </div>
    </div>
  
      <div>
        <div class="uk-light uk-animation-toggle" tabindex="0"><img class="uk-border-circle uk-align-center uk-animation-slide-top-medium" style="margin-bottom: 10px;" src="assets/W/VISMAYA.png"  style="width: 250px; height: 250px;"
            alt="border-circle">
            <h4 class="uk-text-uppercase uk-text-center" style="margin-top: 0px; margin-bottom: 10px;">Vismaya </h4>
            <P class="uk-text-center" style="margin-top:0px ;">Junior Web Developer</P>
        </div>
    </div>
  </div>

</div>    
<br>
<div class="uk-container uk-container-large">
  <h2 class="uk-text-center uk-light">Mobile Development Team</h2>
    <div class="uk-grid-medium uk-child-width-1-2@s uk-child-width-1-4@m uk-grid-match uk-flex-center" uk-grid>
    
        <div>
            <div class="uk-light uk-animation-toggle" tabindex="0"><img class="uk-border-circle uk-align-center 
                uk-animation-slide-top-medium" src="assets/mo/ASWATHY.png" style="width: 250px; height: 250px;
                "alt="border-circle">
                <h4 class="uk-text-uppercase uk-text-center" style="margin-top: 0px; margin-bottom: 10px;">ASWATHY RAJU</h4>
                <P class="uk-text-center" style="margin-top:0px ;">Team lead & Senior Mobile App Developer</P>
            </div>
        </div>
        <div>
        
            <div class="uk-light uk-animation-toggle" tabindex="0"><img class="uk-border-circle uk-align-center 
                uk-animation-slide-top-medium" src="assets/mo/amina.png" style="width: 250px; height: 250px;
                "alt="border-circle">
                
                <h4 class="uk-text-uppercase uk-text-center" style="margin-top: 0px; margin-bottom: 10px;">AMINA U C</h4>
                <P class="uk-text-center" style="margin-top:0px ;">Senior Mobile App Developer</P>
            </div>
        </div>
        <div>
            <div class="uk-light uk-animation-toggle" tabindex="0"><img class="uk-border-circle uk-align-center 
                uk-animation-slide-top-medium" src="assets/mo/ARDHRA.png" style="width: 250px; height: 250px;
                "alt="border-circle">
                <h4 class="uk-text-uppercase uk-text-center" style="margin-top: 0px; margin-bottom: 10px;">ARDHRA CHANDRAN</h4>
                <P class="uk-text-center" style="margin-top:0px ;">Senior Mobile App Developer</P>
            </div>
        </div>
        
        <div>
            <div class="uk-light uk-animation-toggle" tabindex="0"><img class="uk-border-circle uk-align-center 
                uk-animation-slide-top-medium" src="assets/mo/ANAS.png" style="width: 250px; height: 250px;
                "alt="border-circle">
                <h4 class="uk-text-uppercase uk-text-center" style="margin-top: 0px; margin-bottom: 10px;">ANAS</h4>
                <P class="uk-text-center" style="margin-top:0px ;">Senior Mobile App Developer</P>
            </div>
        </div>
        <div>
            <div class="uk-light uk-animation-toggle" tabindex="0"><img class="uk-border-circle uk-align-center 
                uk-animation-slide-top-medium" src="assets/mo/athulsimon.png" style="width: 250px; height: 250px;
                "alt="border-circle">
                <h4 class="uk-text-uppercase uk-text-center" style="margin-top: 0px; margin-bottom: 10px;">athul simon</h4>
                <P class="uk-text-center" style="margin-top:0px ;">Junior Mobile App Developer</P>
            </div>
        </div>
        <div>
            <div class="uk-light uk-animation-toggle" tabindex="0"><img class="uk-border-circle uk-align-center 
                uk-animation-slide-top-medium" src="assets/mo/ceriya.png" style="width: 250px; height: 250px;
                "alt="border-circle">
                <h4 class="uk-text-uppercase uk-text-center" style="margin-top: 0px; margin-bottom: 10px;">Ceriya</h4>
                <P class="uk-text-center" style="margin-top:0px ;">Junior Mobile App Developer</P>
            </div>
        </div>
    </div>
</div>
<br>
<div class="uk-container uk-container-large">
  <h2 class="uk-text-center uk-light">Quality Assurance Team</h2>
  <div class="uk-grid-medium uk-child-width-1-2@s uk-child-width-1-4@m uk-grid-match uk-flex-center" uk-grid>
      <div>
          <div class="uk-light uk-animation-toggle" tabindex="0"><img class="uk-border-circle uk-align-center 
              uk-animation-slide-top-medium" src="assets/Q/ROSELIN.png" style="width: 250px; height: 250px;
               "alt="border-circle">
              <h4 class="uk-text-uppercase uk-text-center" style="margin-top: 0px; margin-bottom: 10px;">ROSELIN THOMAS</h4>
              <P class="uk-text-center" style="margin-top:0px ;">Team Lead & Software Tester</P>
          </div>
      </div>
      <div>
          <div class="uk-light uk-animation-toggle" tabindex="0"><img class="uk-border-circle uk-align-center 
              uk-animation-slide-top-medium" src="assets/Q/ALBIN.png" style="width: 250px; height: 250px;
               "alt="border-circle">
              <h4 class="uk-text-uppercase uk-text-center" style="margin-top: 0px; margin-bottom: 10px;">ALBIN AUGUSTINE</h4>
              <P class="uk-text-center" style="margin-top:0px ;">Software Tester</P>
          </div>
      </div>
      <div>
          <div class="uk-light uk-animation-toggle" tabindex="0"><img class="uk-border-circle uk-align-center 
              uk-animation-slide-top-medium" src="assets/Q/ANJALI.png" style="width: 250px; height: 250px;
               "alt="border-circle">
              <h4 class="uk-text-uppercase uk-text-center" style="margin-top: 0px; margin-bottom: 10px;">ANJALI P PAULSON</h4>
              <P class="uk-text-center" style="margin-top:0px ;">Software Tester</P>
          </div>
      </div>
      <div>
          <div class="uk-light uk-animation-toggle" tabindex="0"><img class="uk-border-circle uk-align-center 
              uk-animation-slide-top-medium" src="assets/Q/APARNA.png" style="width: 250px; height: 250px;
               "alt="border-circle">
              <h4 class="uk-text-uppercase uk-text-center" style="margin-top: 0px; margin-bottom: 10px;">APARNA KARUNADAS</h4>
              <P class="uk-text-center" style="margin-top:0px ;">Software Tester</P>
          </div>
      </div>
     
      <div>
          <div class="uk-light uk-animation-toggle" tabindex="0"><img class="uk-border-circle uk-align-center 
              uk-animation-slide-top-medium uk-text-center" src="assets/Q/HAILY.png" style="width: 250px; height: 250px;
               "alt="border-circle">
              <h4 class="uk-text-uppercase uk-text-center" style="margin-top: 0px; margin-bottom: 10px;">HAILY PAULSON</h4>
              <P class="uk-text-center" style="margin-top:0px ;">Software Tester</P>
          </div>
      </div>

      

     

  </div>

</div>
<br>
<div class="uk-container uk-container-large">
  <h2 class="uk-text-center uk-light">Digital marketing Team</h2>
    <div class="uk-grid-medium uk-child-width-1-2@s uk-child-width-1-4@m uk-grid-match uk-flex-center" uk-grid>
        <div>
            <div class="uk-light uk-animation-toggle" tabindex="0"><img class="uk-border-circle uk-align-center 
                uk-animation-slide-top-medium" src="assets/digital/reshmi.png" style="width: 250px; height: 250px;
                "alt="border-circle">
                <h4 class="uk-text-uppercase uk-text-center" style="margin-top: 0px; margin-bottom: 10px;">RESHMI MOHAN</h4>
                <P class="uk-text-center" style="margin-top:0px ;">Team Lead & Digital Marketing Executive</P>
            </div>
        </div>
        <div>
            <div class="uk-light uk-animation-toggle" tabindex="0"><img class="uk-border-circle uk-align-center 
                uk-animation-slide-top-medium" src="assets/pic5.png" style="width: 250px; height: 250px;
                "alt="border-circle">
                <h4 class="uk-text-uppercase uk-text-center" style="margin-top: 0px; margin-bottom: 10px;">JOJI R</h4>
                <P class="uk-text-center" style="margin-top:0px ;">Digital Marketing Executive</P>
            </div>
        </div>
        <div>
            <div class="uk-light uk-animation-toggle" tabindex="0"><img class="uk-border-circle uk-align-center 
                uk-animation-slide-top-medium" src="assets/digital/syama.png" style="width: 250px; height: 250px;
                "alt="border-circle">
                <h4 class="uk-text-uppercase uk-text-center" style="margin-top: 0px; margin-bottom: 10px;">SYAMA MENON</h4>
                <P class="uk-text-center" style="margin-top:0px ;">Digital Marketing Executive</P>
            </div>
        </div>
        <div>
            <div class="uk-light uk-animation-toggle" tabindex="0"><img class="uk-border-circle uk-align-center 
                uk-animation-slide-top-medium" src="assets/digital/pic6.png" style="width: 250px; height: 250px;
                "alt="border-circle">
                <h4 class="uk-text-uppercase uk-text-center" style="margin-top: 0px; margin-bottom: 10px;">NANDHU KRISHNAN KM</h4>
                <P class="uk-text-center" style="margin-top:0px ;">Digital Marketing Executive</P>
            </div>
        </div>
        
        <div>
            <div class="uk-light uk-animation-toggle" tabindex="0"><img class="uk-border-circle uk-align-center 

                uk-animation-slide-top-medium" src="assets/digital/pic8.png" style="width: 250px; height: 250px;
                "alt="border-circle">
                <h4 class="uk-text-uppercase uk-text-center" style="margin-top: 0px; margin-bottom: 10px;">Akhil M G</h4>
                <P class="uk-text-center" style="margin-top:0px ;">Digital Marketing Executive</P>
            </div>
        </div>
        <div>
            <div class="uk-light uk-animation-toggle" tabindex="0"><img class="uk-border-circle uk-align-center 

                uk-animation-slide-top-medium" src="assets/digital/ajai.png" style="width: 250px; height: 250px;
                "alt="border-circle">
                <h4 class="uk-text-uppercase uk-text-center" style="margin-top: 0px; margin-bottom: 10px;">Ajai</h4>
                <P class="uk-text-center" style="margin-top:0px ;">Digital Marketing Executive</P>
            </div>
        </div>
        <div>
            <div class="uk-light uk-animation-toggle" tabindex="0"><img class="uk-border-circle uk-align-center 

                uk-animation-slide-top-medium" src="assets/digital/jeena.png" style="width: 250px; height: 250px;
                "alt="border-circle">
                <h4 class="uk-text-uppercase uk-text-center" style="margin-top: 0px; margin-bottom: 10px;">jeena hemaraj</h4>
                <P class="uk-text-center" style="margin-top:0px ;">Digital Marketing Executive</P>
            </div>
        </div>
        <div>
            <div class="uk-light uk-animation-toggle" tabindex="0"><img class="uk-border-circle uk-align-center 
                uk-animation-slide-top-medium" src="assets/digital/pic9.png" style="width: 250px; height: 250px;
                "alt="border-circle">
                <h4 class="uk-text-uppercase uk-text-center" style="margin-top: 0px; margin-bottom: 10px;">Vishnu S Unnithan</h4>
                <P class="uk-text-center" style="margin-top:0px ;">Digital Marketing Executive</P>
            </div>
        </div>
     
      
     

    </div>
</div>
<br>
<div class="uk-container uk-container-large">
  <h2 class="uk-text-center uk-light">Graphic Designing Team</h2>
  <div class="uk-grid-medium uk-child-width-1-2@s uk-child-width-1-4@m uk-grid-match uk-flex-center" uk-grid>
      <div>
          <div class="uk-light uk-animation-toggle" tabindex="0"><img class="uk-border-circle uk-align-center 
              uk-animation-slide-top-medium" src="assets/g/ALAN.png" style="width: 250px; height: 250px;
               "alt="border-circle">
              <h4 class="uk-text-uppercase uk-text-center" style="margin-top: 0px; margin-bottom: 10px;">ALAN THOMAS</h4>
              <P class="uk-text-center" style="margin-top:0px ;">Team Lead & Graphic Designer</P>
          </div>
      </div>
      <div>
        <div class="uk-light uk-animation-toggle" tabindex="0"><img class="uk-border-circle uk-align-center 
            uk-animation-slide-top-medium" src="assets/g/DIVYA.png" style="width: 250px; height: 250px;
             "alt="border-circle">
            <h4 class="uk-text-uppercase uk-text-center" style="margin-top: 0px; margin-bottom: 10px;">DIVYA</h4>
            <P class="uk-text-center" style="margin-top:0px ;">Graphic Designer</P>
        </div>
    </div>
     <div>
          <div class="uk-light uk-animation-toggle" tabindex="0"><img class="uk-border-circle uk-align-center 
              uk-animation-slide-top-medium" src="assets/g/JERIN.png" style="width: 250px; height: 250px;
               "alt="border-circle">
              <h4 class="uk-text-uppercase uk-text-center" style="margin-top: 0px; margin-bottom: 10px;">JERIN</h4>
              <P class="uk-text-center" style="margin-top:0px ;">Graphic Designer</P>
          </div>
      </div>
      <div>
        <div class="uk-light uk-animation-toggle" tabindex="0"><img class="uk-border-circle uk-align-center 
            uk-animation-slide-top-medium" src="assets/g/JUSTIN.png" style="width: 250px; height: 250px;
             "alt="border-circle">
            <h4 class="uk-text-uppercase uk-text-center" style="margin-top: 0px; margin-bottom: 10px;">JUSTIN</h4>
            <P class="uk-text-center" style="margin-top:0px ;"> Graphic Designer</P>
        </div>
    </div>
    <div>
        <div class="uk-light uk-animation-toggle" tabindex="0"><img class="uk-border-circle uk-align-center 
            uk-animation-slide-top-medium" src="assets/g/RAHUL.png" style="width: 250px; height: 250px;
             "alt="border-circle">
            <h4 class="uk-text-uppercase uk-text-center" style="margin-top: 0px; margin-bottom: 10px;">RAHUL</h4>
            <P class="uk-text-center" style="margin-top:0px ;">Graphic Designer</P>
        </div>
    </div>
    <div>
        <div class="uk-light uk-animation-toggle" tabindex="0"><img class="uk-border-circle uk-align-center 
            uk-animation-slide-top-medium" src="assets/g/RESHMA.png" style="width: 250px; height: 250px;
             "alt="border-circle">
            <h4 class="uk-text-uppercase uk-text-center" style="margin-top: 0px; margin-bottom: 10px;">RESHMA p</h4>
            <P class="uk-text-center" style="margin-top:0px ;">Graphic Designer</P>
        </div>
    </div>
</div>


